import { useMemo, useState } from "react";

import BaseStats from "components/base/BaseStats";
import {
  DataWrapper,
  Section,
  SectionContentScroll,
  SectionContent,
  SectionTitle,
} from "components/base/DataScreenBase";
import DerivedStats from "components/base/DerivedStats";
import UpgradeInventory from "components/base/UpgradeInventory";
import styled from "styled-components";
import { CharacterBaseStats } from "types";
import { useSelector } from "react-redux";
import { getInstalledUpgrades } from "redux/selectors/characterSelectors";
import InstalledUpgrades from "components/base/InstalledUpgrades";
import {
  getShipUpgradesData,
  getUpgradeData,
  getUpgradeComparisonStats,
} from "libs/item";

const SectionContentSmall = styled(SectionContent)`
  flex-basis: 25%;
  flex-shrink: 0;
  flex-grow: 0;
  margin-top: 20px;
`;

const SectionSmall = styled(Section)`
  flex-basis: 33%;
`;

export default function BuildScreen() {
  const installedUpgrades = useSelector(getInstalledUpgrades);

  const [highlightStat, setHighlightStat] = useState<
    keyof CharacterBaseStats | null
  >(null);
  const [previewUpgrade, setPreviewUpgrade] = useState<string | null>(null);

  const previewDiff = useMemo(() => {
    if (!previewUpgrade) return null;

    const upgradeData = getUpgradeData(previewUpgrade);
    const shipUpgrades = getShipUpgradesData(installedUpgrades);

    const installedShipUpgrade = shipUpgrades[upgradeData.part];
    const installedStats = !!installedShipUpgrade
      ? installedShipUpgrade.derivedStats
      : {};

    return getUpgradeComparisonStats(upgradeData.derivedStats, installedStats);
  }, [previewUpgrade, installedUpgrades]);

  console.log(previewDiff);

  return (
    <DataWrapper>
      <SectionSmall>
        <SectionTitle>Base Stats</SectionTitle>
        <SectionContentScroll>
          <BaseStats
            atShipworks
            onSetHighlightStat={(stat) => setHighlightStat(stat)}
            onResetHighlightStat={() => setHighlightStat(null)}
          />
        </SectionContentScroll>
      </SectionSmall>
      <SectionSmall>
        <SectionTitle>Upgrades</SectionTitle>
        <SectionContentScroll>
          <UpgradeInventory
            atShipworks
            onHoverUpgrade={(upgradeSlug) => setPreviewUpgrade(upgradeSlug)}
          />
        </SectionContentScroll>
        <SectionContentSmall>
          <InstalledUpgrades atShipworks />
        </SectionContentSmall>
      </SectionSmall>
      <SectionSmall>
        <SectionTitle>Derived Stats</SectionTitle>
        <SectionContentScroll>
          <DerivedStats
            highlightStat={highlightStat}
            previewDiff={previewDiff}
          />
        </SectionContentScroll>
      </SectionSmall>
    </DataWrapper>
  );
}
